import { MotionValue, motion, useTransform } from 'framer-motion'
import { FC, ReactNode } from 'react'
import styled from 'styled-components/macro'

import { containerStyle } from 'components/container'
import { useDigitsContext } from 'context/digits-context'

const Svg = styled.svg`
  ${containerStyle}
  display: block;
  position: relative;
  /* width: 59rem; */
  width: auto;
  height: 100%;
  overflow: visible;

  .digit {
    font-family: RadioDigits;
    text-anchor: middle;
    letter-spacing: 0.1em;
    fill: #d2cfcf;
    font-size: 10px;
  }
`

const Container = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: var(--header-height);
  left: 0;
  width: 100%;
  height: var(--timeline-height);
  user-select: none;
  touch-action: none;
  background-color: #181e23;
  z-index: 1;

  &::before {
    content: '';
    display: block;
    position: absolute;
    border-top: 2px solid #d78475;
    width: 100%;
  }
`

type Props = {
  progress: MotionValue<number>
  onScroll: (delta: number) => void
  children?: ReactNode
}

export const Timeline: FC<Props> = ({ progress, onScroll, children }) => {
  const { timelineCoords, width } = useDigitsContext()
  const transform = useTransform(progress, [0, width], [0, -width])

  return (
    <Container onPan={(_evt, info) => onScroll(-info.delta.x)}>
      <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 542 45">
        {/* <line
          x1="0"
          y1="22"
          x2="542"
          y2="22"
          stroke="#d78475"
          strokeWidth={2}
        /> */}

        <motion.g style={{ translateX: transform }}>
          {timelineCoords.map(coord => (
            <rect
              x={coord.x - 22}
              y="17"
              width="50"
              height="11"
              fill="#181B20"
              key={coord.value}
            />
          ))}
        </motion.g>

        <rect
          data-name="slider"
          x="170"
          y="5"
          width="5"
          height="35"
          fill="#f24b3a"
        />

        <motion.g style={{ translateX: transform }}>
          {timelineCoords.map(coord => (
            <text x={coord.x + 3} y="27" className="digit" key={coord.value}>
              {coord.value}
            </text>
          ))}
        </motion.g>
      </Svg>
    </Container>
  )
}
